import styled from 'styled-components';

interface FormContainerProps {
  $isLoading: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 15px;
`;

export const VisuallyHiddenLabel = styled(Label)`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  border: 0;
  white-space: nowrap;
`;

export const BinCollectionButtonStyles = styled.div`
    button {
      margin: 10px 10px 12px 10px;
    }
`;

export const FormContainer = styled.div<FormContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${(props) => 
      props.$isLoading && `
          opacity: 0.5; 
          pointer-events: none;
      `
  }
`;

export const ErrorTextWrapper = styled.div`
  display: block;
  width: 100%;
`;

export const DropDownSelectContainer = styled.div`
  padding-bottom: 20px;
  width: 90%;
`;

export const FormInnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const FormLabel = styled.label`
  display: flex;
  align-items: center;
  margin-right: ${(props) => props.theme.theme_vars.spacingSizes.$small};
`;

export const UPRNPageUPRNRow = styled.div`
  display: flex;
  justify-content: left;
  margin-bottom: .5em;
  width: 100%;
`;

export const HomePageResetButton = styled.input``;
